// Konfiguration der Kies-/Schüttgut-Landingpages. Geteilt von React-Pages und
// scripts/prerender.js (vm-Shim, daher reines `export const`).
export const SCHUETTGUT_SEITEN = [
  {
    slug: "schotter-berechnen",
    material: "schotter",
    title: "Schotter berechnen: Menge, Tonnen und Big Bags für deine Fläche",
    description: "Schottermenge berechnen: Fläche und Schütthöhe eingeben und Volumen in m³, Gewicht in Tonnen und Anzahl Big Bags sehen.",
    h1: "Schotter berechnen",
    intro: "Gib die Fläche (Länge × Breite) und die gewünschte Schütthöhe ein, der Rechner zeigt dir die benötigte Schottermenge in Kubikmeter, das Gewicht in Tonnen und die Anzahl Big Bags. Für andere Materialien wähle oben das passende aus.",
    faq: [
      { q: "Wie viel Schotter brauche ich pro Quadratmeter?", a: "Pro m² und cm Schütthöhe sind es 0,01 m³. Bei 5 cm Höhe also 0,05 m³ pro m². Schotter wiegt rund 1,6 Tonnen pro m³." },
      { q: "Wie viel wiegt ein Kubikmeter Schotter?", a: "Lose geschüttet etwa 1,6 Tonnen pro m³. Verdichtet liegt das Gewicht etwas höher." },
    ],
  },
  {
    slug: "kies-berechnen",
    material: "kies",
    title: "Kies berechnen: Kiesmenge in m³, Tonnen und Big Bags",
    description: "Kiesmenge berechnen: Fläche und Schütthöhe eingeben und Volumen, Gewicht und Anzahl Big Bags sofort sehen.",
    h1: "Kies berechnen",
    intro: "Für eine Kiesfläche zählt Länge mal Breite mal Schütthöhe. Gib deine Maße ein, der Rechner liefert Volumen in m³, Gewicht in Tonnen und die Anzahl Big Bags.",
    faq: [
      { q: "Wie viel Kies brauche ich für meine Fläche?", a: "Fläche in m² mal Schütthöhe in Metern ergibt das Volumen. Beispiel: 50 m² bei 5 cm = 2,5 m³. Kies wiegt rund 1,6 Tonnen pro m³." },
    ],
  },
  {
    slug: "splitt-berechnen",
    material: "splitt",
    title: "Splitt berechnen: Splittmenge für Fläche und Schütthöhe",
    description: "Splittmenge berechnen: Fläche und Höhe eingeben, Volumen in m³, Gewicht in Tonnen und Big Bags sehen.",
    h1: "Splitt berechnen",
    intro: "Splitt liegt oft als dünne Schicht, etwa im Pflasterbett. Gib Fläche und Schütthöhe ein, der Rechner zeigt Volumen, Gewicht und Anzahl Big Bags.",
    faq: [
      { q: "Wie viel wiegt Splitt pro Kubikmeter?", a: "Splitt wiegt lose rund 1,5 Tonnen pro m³, Basaltsplitt etwas mehr (etwa 1,7 t/m³)." },
    ],
  },
  {
    slug: "zierkies-berechnen",
    material: "zierkies",
    title: "Zierkies berechnen: Menge für die Gartenfläche",
    description: "Zierkies berechnen: Fläche und Schütthöhe eingeben und benötigte Menge in m³, Tonnen und Big Bags sehen.",
    h1: "Zierkies berechnen",
    intro: "Für Zierkies im Garten oder Beet zählt die Fläche mal die Schütthöhe. Gib deine Maße ein und du bekommst Volumen, Gewicht und Anzahl Big Bags.",
    faq: [
      { q: "Wie hoch sollte eine Zierkiesschicht sein?", a: "Als Sichtschicht reichen oft 3 bis 5 cm, als begehbare Fläche eher 5 bis 8 cm. Der Rechner nimmt deine Höhe und liefert die Menge." },
    ],
  },
];

export const SCHUETTGUT_HUB = {
  slug: "kiesrechner",
  title: "Kiesrechner: Schotter, Kies und Splitt in m³, Tonnen und Big Bags",
  description: "Kostenloser Schüttgut-Rechner für Schotter, Kies, Splitt und Zierkies. Fläche und Schütthöhe eingeben, Menge, Gewicht und Big Bags sofort sehen.",
  h1: "Kies- und Schüttgut-Rechner",
  faq: [
    { q: "Wie berechne ich die Menge an Kies oder Schotter?", a: "Fläche (Länge × Breite) mal Schütthöhe ergibt das Volumen in m³. Multipliziert mit der Schüttdichte ergibt sich das Gewicht. Der Rechner macht das für jedes Material automatisch." },
    { q: "Wie viele Big Bags brauche ich?", a: "Big Bags fassen meist 1 Tonne. Da Kies und Schotter dicht sind, begrenzt das Gewicht die Füllmenge. Der Rechner zählt die Big Bags daher über das Gewicht, nicht über das Volumen." },
  ],
};
